import { useState } from "react";

import { EditEventForm } from "Bands/containers";
import { useEventContext } from "Bands/contexts";
import { IEvent } from "Bands/types";
import { copy } from "shared/assets";
import { CalendarAdd } from "shared/assets/icons";
import { Card } from "shared/components";
import { Spacer } from "shared/layout";

const eventCopy = copy.event.edit;

export const EditEventPage = () => {
  const { event, userPermissions } = useEventContext();

  const [placeholder, setPlaceholder] = useState<Partial<IEvent>>(event || {});

  return (
    <Spacer size="l">
      <Card title={eventCopy.title} icon={CalendarAdd} titleHeading="h2">
        <EditEventForm
          placeholder={placeholder}
          updatePlaceholder={setPlaceholder}
          canDeleteEvent={userPermissions.DELETE}
        />
      </Card>
    </Spacer>
  );
};
